import React, { useEffect, useState } from "react";
import NewEmrTemplate from "./NewEmrTemplate";
import {
  DeleteIcon,
  EditIcon,
  ForceCloseIcon,
} from "../../../assets/CommonAssets";

import { Box, Modal, Tooltip } from "@mui/material";
import CommonDynamicTableNew from "../../../common/components/CommonTable/CommonDynamicTableNew";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import {
  deleteEMRTemplate,
  emrTemplateInfoDetails,
  emrTemplateList,
} from "../../services/emrTemplateServices/EMRTemplateServices";
import {
  errorAlert,
  successAlert,
} from "../../../common/components/Toasts/CustomToasts";
import { doctorDropdown } from "../../services/patientappointmentservices/PatientVisitListServices";
import { useForm } from "react-hook-form";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";

const ModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  // maxHeight: "90%",
  width: "97%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "1px solid gray",
  boxShadow: 20,
  // borderRadius: "10px",
  overflowY: "auto",
  p: 2,
};

// const templateObj = [
//   { value: 1, label: "Dental Template", id: 1 },
//   { value: 2, label: "Cardiology Template", id: 2 },
//   { value: 3, label: "ENT Template", id: 3 },
//   { value: 4, label: "Fever Template", id: 4 },
//   { value: 5, label: "Neurology Template", id: 5 },
//   { value: 6, label: "Orthopedic Template", id: 6 },
//   { value: 7, label: "Dermatology Template", id: 7 },
//   { value: 8, label: "Pediatrics Template", id: 8 },
//   { value: 9, label: "Psychiatry Template", id: 9 },
//   { value: 10, label: "Ophthalmology Template", id: 10 },
//   { value: 11, label: "Gastroenterology Template", id: 11 },
//   { value: 12, label: "Endocrinology Template", id: 12 },
//   { value: 13, label: "Pulmonology Template", id: 13 },
//   { value: 14, label: "Nephrology Template", id: 14 },
//   { value: 15, label: "Urology Template", id: 15 },
// ];

function EmrTemplate({ open, close }) {
  let token = JSON.parse(localStorage.getItem("userInfo"));
  const { control, watch } = useForm({
    mode: "onChange",
    defaultValues: {
      doctor: null,
    },
  });
  const [selectedTab, setSelectedTab] = useState(0);
  const [templateNameList, setTemplateNameList] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [editRow, setEditRow] = useState(null);
  const [selectedTemplateDetails, setSelectedTemplateDetails] = useState(null);
  const [doctor, setDoctor] = useState();

  const getDoctorId = watch("doctor");

  // useEffect(() => {
  //   const handleKeyDown = (e) => {
  //     if (selectedTab === 0) {
  //       const currentIndex = templateNameList.findIndex(
  //         (temp) => temp.id === selectedRow
  //       );
  //       if (e.key === "ArrowUp" && currentIndex > 0) {
  //         setSelectedRow(templateNameList[currentIndex - 1].id);
  //       } else if (
  //         e.key === "ArrowDown" &&
  //         currentIndex < templateNameList.length - 1
  //       ) {
  //         setSelectedRow(templateNameList[currentIndex + 1].id);
  //       }
  //     }
  //   };
  //   window.addEventListener("keydown", handleKeyDown);
  //   return () => window.removeEventListener("keydown", handleKeyDown);
  // }, [selectedRow, templateNameList, selectedTab]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedTab === 0) {
        const currentIndex = templateNameList.findIndex(
          (temp) => temp.id === selectedRow
        );

        if (e.key === "ArrowUp" && currentIndex > 0) {
          setSelectedRow(templateNameList[currentIndex - 1].id);
        } else if (
          e.key === "ArrowDown" &&
          currentIndex < templateNameList.length - 1
        ) {
          setSelectedRow(templateNameList[currentIndex + 1].id);
        } else if (e.key === "Enter" && selectedRow !== null) {
          e.preventDefault();
          setSelectedTab(1);
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [selectedRow, selectedTab, templateNameList]);

  const handleRowSelect = (tempId) => {
    if (tempId !== null) {
      setSelectedTemplateDetails(null);
      setSelectedRow(tempId);
      emrTemplateInfoDetails(tempId)
        .then((response) => response.data)
        .then((res) => {
          setSelectedTemplateDetails(res.result);
        })
        .catch((error) => error);
    } else {
      setSelectedTemplateDetails([]);
    }
  };
  const getDoctorDropdownList = (searchDoctorString) => {
    if (searchDoctorString !== "") {
      doctorDropdown(searchDoctorString)
        .then((response) => response.data)
        .then((res) => {
          if (searchDoctorString !== null) {
            setDoctor(res.result);
          }
        });
    }
  };

  const populateTable = () => {
    emrTemplateList(
      getDoctorId !== null
        ? getDoctorId?.id
        : token?.doctorId !== null
        ? token?.doctorId
        : 0
    )
      .then((response) => response.data)
      .then((res) => {
        setTemplateNameList(res.result);
      })
      .catch((error) => error);
  };

  useEffect(() => {
    populateTable();
  }, [getDoctorId]);

  const handleDeleteTemplate = (row) => {
    if (row !== null) {
      deleteEMRTemplate(row)
        .then((response) => response.data)
        .then((res) => {
          successAlert(res.message);
          populateTable();
        })
        .catch((err) => {
          errorAlert(err.message);
        });
    }
  };

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={ModalStyles} className="h-[75%]">
        <div className="space-y-2">
          <div className="flex justify-between">
            <div className="flex justify-center font-bold font-Poppins text-xl ">
              Template Creations
            </div>
            <div className="flex border rounded relative">
              <div
                className={`absolute top-0 h-full w-32 bg-customBlue  rounded transition-transform duration-300 ease-in-out`}
                style={{
                  transform: `translateX(${selectedTab * 100}%)`,
                }}
              />
              <button
                className={`${
                  selectedTab === 0 ? "text-white" : "text-black"
                } w-32 text-sm rounded z-10 relative `}
                onClick={() => {
                  setSelectedTab(0);
                  setSelectedRow(null);
                  setEditRow(null);
                }}
              >
                TEMPLATE
              </button>
              <button
                className={`${
                  selectedTab === 1 ? "text-white" : "text-black"
                } w-32 text-sm rounded z-10 relative`}
                onClick={() => {
                  setSelectedTab(1);
                }}
              >
                NEW
              </button>
            </div>
            <div className="flex items-center">
              <button onClick={close} type="button">
                <CancelPresentationIconButton />
              </button>
            </div>
          </div>

          {selectedTab === 0 && (
            <div className="flex gap-2">
              <div className="w-[30%] border  rounded-md shadow-md">
                {token?.doctorId === null && (
                  <div className="w-[90%] pl-1 py-2">
                    <SearchDropdown
                      control={control}
                      name="doctor"
                      placeholder="Doctor"
                      label="Doctor"
                      isSearchable={true}
                      searchIcon={true}
                      isClearable={true}
                      dataArray={doctor}
                      handleInputChange={getDoctorDropdownList}
                    />
                  </div>
                )}

                <h2 className="bg-customBlue text-center py-1 font-semibold  font-Poppins rounded-t text-white">
                  Template Name
                </h2>
                <div className="h-[65vh] overflow-y-auto">
                  {templateNameList.map((temp, index) => (
                    <div
                      className={`flex p-[1px] items-center border-b px-2 cursor-pointer ${
                        selectedRow === temp.id ? "bg-yellow-400" : ""
                      }`}
                      key={index}
                      onClick={() => handleRowSelect(temp.id)}
                      tabIndex={0}
                    >
                      <div>
                        <Tooltip title="Edit">
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              setEditRow(temp?.id);
                              setSelectedTab(1);
                            }}
                          >
                            <EditIcon />
                          </button>
                        </Tooltip>
                      </div>
                      <div>
                        <Tooltip title="Delete">
                          <button
                            type="button"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDeleteTemplate(temp?.id);
                            }}
                          >
                            <DeleteIcon />
                          </button>
                        </Tooltip>
                      </div>

                      <div className="pl-2 -mt-[5px]">
                        <h3 className="text-sm capitalize font-Poppins">
                          {temp?.label}
                        </h3>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="w-[70%] border rounded-md shadow-md px-4 p-2">
                {selectedTemplateDetails && selectedRow && (
                  <div className="space-y-2">
                    <h2 className="text-center text-xl font-semibold">
                      {
                        templateNameList.find((temp) => temp.id === selectedRow)
                          ?.label
                      }
                    </h2>

                    <div>
                      {selectedTemplateDetails?.diagnosis && (
                        <div>
                          <h2 className="font-semibold">Diagnosis</h2>
                          {selectedTemplateDetails?.diagnosis.map(
                            (digno, index) => (
                              <ul key={index} className="px-12">
                                <li className="list-disc capitalize">
                                  {digno?.diagnosis?.diagnosis}
                                </li>
                              </ul>
                            )
                          )}
                        </div>
                      )}
                    </div>

                    <div>
                      {selectedTemplateDetails?.services && (
                        <div>
                          <h2 className="font-semibold">Services</h2>
                          <div className="columns-3">
                            {selectedTemplateDetails?.services.map(
                              (inv, index) => (
                                <ul className="px-12" key={index}>
                                  <li className="list-disc">
                                    {inv?.service?.description}
                                  </li>
                                </ul>
                              )
                            )}
                          </div>
                        </div>
                      )}
                    </div>

                    <div>
                      {selectedTemplateDetails?.items?.length > 0 ? (
                        <CommonDynamicTableNew
                          dataResult={selectedTemplateDetails?.items}
                          tableClass={"capitalize"}
                          highlightRow={false}
                          removeHeaders={[
                            "itemId",
                            "formId",
                            "frequencyId",
                            "genericId",
                            "instructionId",
                            "routeId",
                            "id",
                          ]}
                        />
                      ) : (
                        []
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {selectedTab === 1 && (
            <div>
              <NewEmrTemplate
                editRow={editRow}
                setSelectedRow={setSelectedRow}
                setSelectedTab={setSelectedTab}
                populateTable={populateTable}
                getDoctorId={getDoctorId}
              />
            </div>
          )}
        </div>
      </Box>
    </Modal>
  );
}

export default EmrTemplate;
